import { z } from "zod";
import { ZDateish } from "./commonSchema";
export const ZMaconomyEmployeeAccess = z.object({
    projectNo: z.number(),
    employeeNumber: z.string().min(1),
    transactionTimestamp: ZDateish.optional(),
});
